import {
  faArrowRight,
  faGraduationCap,
  faRupee,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AxiosClient from "../client/AxiosClient";
import { API_POPULAR_COURSES, API_SECTION_COURSES } from "../ApiEndPoints";
import CourseCardTile from "../component/CourseCardTile";

import Loader from "../component/Loader";
import { FilledPrimaryBtn } from "../component/FilledBtn";
import {
  PrimaryIconOutlineBtnLink,
  PrimaryOutlineBtnLink,
} from "../component/OutlineBtn";

export default function CoursesGrid2() {
  const [loading, setLoading] = useState(true);
  const [popularCourses, setPopularCourses] = useState([]);
  const serverUrl = process.env.REACT_APP_SERVER_BASE_URL;

  useEffect(() => {
    AxiosClient.get(API_SECTION_COURSES, {
      params: {
        where_field_name: "show_in_new_course",
        where_field_value: 1,
        limit: 8,
      },
    })
      .then((response) => {
        const listData = response.data.data;

        setPopularCourses(listData);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className="bg-lightaccent">
      <div className="container">
        <h2 className="sec-title text-center">New Courses</h2>
        <p className="sec-short-desc text-center">
          Discover the latest online courses to enhance your skills and
          knowledge.
        </p>

        <div>
          <div className="row">
            {loading && (
              <div className="col-12 text-center">
                <Loader classes="text-primary" />
              </div>
            )}

            {!loading &&
              popularCourses.map((row, index) => {
                return (
                  <div
                    className="col-sm-6 col-md-6 col-lg-3"
                    key={`course-grid-sec${index}`}
                  >
                    <CourseCardTile
                      title={row.title}
                      category={row.category_name}
                      thumbnail={serverUrl + row.thumbnail}
                      price={row.price}
                      instructorName={row.instructor_name}
                      discountPrice={row.discount_price}
                      link={`/courses/${row.slug}`}
                    />
                  </div>
                );
              })}

            <div className="col-12 d-flex align-items-center justify-content-center">
              {!loading && (
                <PrimaryIconOutlineBtnLink
                  label={"View all"}
                  link={"/new-courses"}
                  classes="d-block d-md-inline-block "
                  fontAwesomeIcon={faArrowRight}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
